import { render } from "./DeleteVan.vue?vue&type=template&id=690a2713"
import script from "./DeleteVan.vue?vue&type=script&lang=js"
export * from "./DeleteVan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__